const TOP_NAV_PUBLIC = {
    label: 'root',
    rank: 0.0,
    subMenus: {
        myImages: {
            label: 'my images',
            rank: -5,
            description: 'Gallery of images',
            link: '/images/my',
            router: true,
        },
        gallery: {
            label: 'gallery',
            rank: -4,
            description: 'Demo images gallery',
            link: '/demo',
            router: true,
        },
        support: {
            label: 'support',
            rank: -3,
            description: 'Support information',
            link: '/support',
            router: true,
        },
        contacts: {
            label: 'contacts',
            rank: -2,
            description: 'Contact information',
            link: '/contacts',
            router: true,
        },
        about: {
            label: 'about',
            rank: -1,
            description: 'About the company',
            link: '/about',
            router: true,
        },
    }
};

const topNavAuthenticated = (user) => {
    const menus = {...TOP_NAV_PUBLIC};

    menus.subMenus.user = {
        label: '',
        rank: -0.2,
        description: `${user.email}`,
        icon: 'fa fa-user',
        subMenus: {
            current: {
                label: `${user.email}`,
                description: `${user.email}`,
                rank: 1.0,
                disabled: true,
                cssClass: 'signed-in-as',
            },
            _divider: {
                label: '',
                rank: 1.5,
                divider: true,
            },
            presets: {
                label: 'presets',
                rank: 2.0,
                description: 'User presets',
                link: '/presets',
                router: true,
            },
            profile: {
                label: 'profile',
                rank: 2.0,
                description: 'User Profile',
                link: '/profile',
                router: true,
            },
            view: {
                label: 'view',
                rank: 3,
                subMenus: {
                    processing: {
                        dynamicLabel: true,
                        rank: 1,
                        callback: true,
                    }
                }
            },
            _divider1: {
                label: '',
                rank: 99,
                divider: true,
            },
            signOut: {
                label: 'sign out',
                rank: 100,
                description: 'Sign Out',
                link: '/logout',
                router: true,
            }
        }
    };
    return menus;
};

const topNavAdmin = (user) => {
    const menus = topNavAuthenticated(user);
    menus.subMenus.admin = {
        label: 'admin',
        rank: -0.5,
        subMenus: {
            users: {
                label: 'users',
                rank: 1.0,
                description: 'User Management',
                link: '/admin/users',
                router: true,
            },
        }
    };
    return menus;
};

export const topNav = (user, isAuthenticated) => {
    if (!isAuthenticated) {
        return TOP_NAV_PUBLIC;
    }
    if (user.admin) {
        return topNavAdmin(user);
    }
    return topNavAuthenticated(user);
};




// WEBPACK FOOTER //
// ./src/config/Nav.js